import LocalizationOn from './LocalizationOn';

export default LocalizationOn;
